import React from "react";
import { Link } from "react-router-dom";
import "./Constructiondebrisheader.css";

export default function Constructiondebrisheader() {
  const base = process.env.PUBLIC_URL;

  return (
    <section
      className="cd-hero"
      role="banner"
      aria-label="Construction Debris Removal hero banner"
    >
      {/* Background image (full width) */}
      <img
        className="cd-hero__bg"
        src={`${base}/(232).webp`}
        alt="Construction debris removal team at work"
        loading="eager"
      />

      {/* Contrast overlay */}
      <div className="cd-hero__overlay" aria-hidden="true" />

      {/* Centered content */}
      <div className="cd-hero__content">
        <nav className="cd-hero__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="cd-hero__breadcrumb-link">Home</Link>
          <span className="cd-hero__breadcrumb-sep" aria-hidden="true">›</span>
          <span className="cd-hero__breadcrumb-current">Construction Debris Removal</span>
        </nav>

        <h1 className="cd-hero__title">Construction Debris Removal</h1>
        <p className="cd-hero__subtitle">
          Efficient, safe removal for cleaner job sites and faster turnarounds.
        </p>
      </div>

      {/* Premium depth touches */}
      <div className="cd-hero__vignette" aria-hidden="true" />
      <div className="cd-hero__grain" aria-hidden="true" />
    </section>
  );
}
